module.exports = __webpack_public_path__ + "img/517919_659623_34460C_3E5813-256px.543a1022.png";